module.exports = __webpack_public_path__ + "img/objTable.2a0ce749.svg";